/* tslint:disable */
/* eslint-disable */
/**
 * Credit API
 * API for banking integrations
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface MoneytreeCallbackPayload
 */
export interface MoneytreeCallbackPayload {
    /**
     * Authorization code from Moneytree
     * @type {string}
     * @memberof MoneytreeCallbackPayload
     */
    'code': string;
    /**
     * State parameter for CSRF protection
     * @type {string}
     * @memberof MoneytreeCallbackPayload
     */
    'state': string;
    /**
     * Next action to perform after callback
     * @type {string}
     * @memberof MoneytreeCallbackPayload
     */
    'nextTo': MoneytreeCallbackPayloadNextToEnum;
}

export const MoneytreeCallbackPayloadNextToEnum = {
    registration: 'BANK_ACCOUNT_REGISTRATION',
    relink: 'BANK_ACCOUNT_RELINK'
} as const;

export type MoneytreeCallbackPayloadNextToEnum = typeof MoneytreeCallbackPayloadNextToEnum[keyof typeof MoneytreeCallbackPayloadNextToEnum];


